import { useMemo } from "react";
import { UncontrolledTooltip } from "reactstrap";
import toast from "react-hot-toast";
import { Copy } from "react-feather";

import NewBadge from "components/Structure/Badge/newBadge";
import { limitCaracter } from "utils";

export const TooltipInfo = ({
  row,
  fieldKey,
  field,
  color,
  subField = "",
  limit = 40,
  isBadge = false,
  isCopy = false,
}) => {
  const handleCopy = value => {
    navigator.clipboard.writeText(value);

    return toast.success(`Copiou ${value}`);
  };
  const idTooltip = `˜${row[fieldKey]?.toString()}-tooltip-${field}-${
    isBadge ? "badge" : ""
  }`;
  const value = useMemo(() => {
    if (subField && row[field] && row[field][subField] !== undefined) {
      return row[field][subField] || "";
    }

    return row[field] || "";
  }, [field, subField, row]);

  return (
    <>
      {!isBadge ? (
        <p className="m-0" id={idTooltip}>
          {value ? limitCaracter(limit, value) : "---"}&nbsp;
          {isCopy && (
            <Copy
              size={11}
              onClick={() => handleCopy(value)}
              style={{ cursor: "pointer" }}
            />
          )}
        </p>
      ) : (
        <NewBadge
          isCopy={isCopy}
          pill
          color={color}
          id={idTooltip}
          value={value ? limitCaracter(limit, value) : "---"}
        />
      )}

      <UncontrolledTooltip placement="top" target={idTooltip}>
        {value ? value : "Não informado'"}
      </UncontrolledTooltip>
    </>
  );
};
